/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { Undo2 } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
export function ConsultarEntregaDtpPage() {
  const [s, setS] = useState<any>();
  const NS = '/bff/v1/j07-s04-consultar-dtp';
  async function call(p: string, b?: any) {
    const r = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST', corpo: b });
    setS(r.state);
  }
  useEffect(() => {
    void call('/state');
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando conjunto de fechamento…
      </main>
    );
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">{s.titulo}</h1>
        <p>{s.descricao}</p>
      </header>
      {s.apontamentos.map((a: any) => (
        <article className="space-y-3 rounded-md border p-4" key={a.id}>
          <h2 className="font-semibold">
            {a.protocolo} · {a.status}
          </h2>
          <p>
            Versão {a.versao} · {a.dados.totais.quilometragem} km · edição pelo DTP: não permitida
          </p>
          <Button
            variant="outline"
            disabled={a.status !== 'ENTREGUE_DTP'}
            onClick={() =>
              void call('/verbs/devolver_sme', {
                submissaoId: a.id,
                motivo:
                  'DTP solicita à SME a reconferência formal do conjunto, sem alterar linhas ou autoria.',
                chaveIdempotencia: `j07-s04-devolver-${a.id}-v${a.versao}`,
              })
            }
          >
            <Undo2 className="mr-2 h-4 w-4" />
            Devolver à SME
          </Button>
          <ol aria-label="Auditoria">
            {a.historico.map((h: any) => (
              <li key={h.id}>
                {h.atorPapel}: {h.tipo} — {h.motivo}
              </li>
            ))}
          </ol>
        </article>
      ))}
    </main>
  );
}
